import { render, staticRenderFns } from "./CandidateInvitation.vue?vue&type=template&id=5c78d8d8&scoped=true&"
import script from "./CandidateInvitation.vue?vue&type=script&lang=js&"
export * from "./CandidateInvitation.vue?vue&type=script&lang=js&"
import style0 from "./CandidateInvitation.vue?vue&type=style&index=0&id=5c78d8d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c78d8d8",
  null
  
)

/* custom blocks */
import block0 from "./CandidateInvitation.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CandidateInvitation.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
